export function getBlockOrder(block) {
  return parseInt(block.closest("[data-block-gsap-order]").getAttribute('data-block-gsap-order')) || 0;
}
